module.exports = __webpack_public_path__ + "img/L_9D.af3700be.png";